import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import WrapperContent from "../../components/shared/WrapperContent";
import { useSelector } from "react-redux";
import HeaderContentNew from "../../components/shared/HeaderContentNew/HeaderContentNew";
import PartnersItemTable from "../../components/partners/PartnersItemTable";
import { toast } from "react-toastify";

const PartnersPage = () => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const [isAddTransportCompany, setAddTransportCompany] = useState(false);

    const handleAddClick = () => {
      if (user && !user.permissions?.includes("employer_add")) {
        toast.info(t('partners.toast.accessDenied'), {
          autoClose: 10000
        });
        return;
      } else {
        setAddTransportCompany(true);
      }
    };

  return (
    <>
      <HeaderContentNew
        displayTitle
        title={t('partners.pageTitle')}
        practicalTitle={t('partners.button.addCompany')}
        onPracticalBtnClick={() => {
          handleAddClick();
        }}
      />

      <WrapperContent>
        <PartnersItemTable
          isShowModal={isAddTransportCompany}
          setShowModal={setAddTransportCompany}
          user={user}
        />
      </WrapperContent>
    </>
  );
};

export default PartnersPage;
